module.exports = __webpack_public_path__ + "img/honor15.087558ac.png";